import styled, { css } from "styled-components";

import { BFC_PREVIEW_BAR_THUMB_SIZE } from "../../constants/constants";

export const ExtraWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const fullVariant = css`
  max-height: 200px;

  // *Above* iPhone 5
  @media (min-width: 321px) {
    max-height: 230px;
  }

  // *Above* iPhone 6/7/8
  @media (min-width: 376px) {
    max-height: 255px;
  }

  // iPhone 6/7/8 Plus
  @media (min-width: 414px) {
    max-height: 260px;
  }

  // *Above* iPhone 6/7/8 Plus
  @media (min-width: 415px) {
    max-height: 370px;
  }

  @media (min-width: 768px) {
    max-height: 320px;
  }

  @media (min-width: 1024px) {
    max-height: 370px;
  }

  @media (min-width: 1280px) {
    max-height: 400px;
  }
`;

const thumbVariant = css`
  width: ${BFC_PREVIEW_BAR_THUMB_SIZE};
  height: ${BFC_PREVIEW_BAR_THUMB_SIZE};
  max-width: none;
  flex: none;

  .PartImage {
    position: absolute;
    top: 0;
    left: 0;
    transform: none;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    transition: none;
    animation: none;

    &.placeholder {
      visibility: hidden;
    }
  }
`;

// The placeholder keeps its natural width so the stack is never scaled beyond
// the source resolution, which is only 500px for older models.
const lightboxVariant = css`
  width: auto;
  max-width: 100%;
  max-height: none;

  .PartImage {
    max-height: none;
    transition: none;
    animation: none;

    &.placeholder {
      position: relative;
      visibility: hidden;
      width: auto;
      max-width: 100%;
    }
  }
`;

const variants = {
  full: fullVariant,
  thumb: thumbVariant,
  lightbox: lightboxVariant,
};

export const ImagesContainer = styled.div`
  position: relative;
  display: block;
  width: 100%;
  max-width: 520px;

  ${(props) => variants[props.$variant] || fullVariant}
`;

const imagePosition = `
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const PartImage = styled.img`
  -webkit-transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    margin-top 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    margin-top 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  ${imagePosition}
  width: ${(props) =>
    props.smaller && props.frameType === "FIRAXL" ? "75%" : "100%"};
  max-height: ${(props) =>
    props.frameType === "FIRAXL" ||
    props.frameType === "LYCKA" ||
    props.frameType === "FIRAVINKEL"
      ? "100%"
      : "inherit"};
  max-width: 100%;
  object-fit: cover;

  &:first-child {
    position: relative;
  }

  @media (min-width: 768px) {
    &.placeholder {
      position: relative;
      visibility: hidden;
    }

    &.animate {
      max-width: 130%;
      animation: move 0.5s;
      @keyframes move {
        0% {
          width: 130%;
          opacity: 0.2;
        }
        100% {
          width: 100%;
          opacity: 1;
        }
      }
    }
  }
`;
